import React from 'react';
export const StatusContext = React.createContext({
    status: null,
    ariaDescribedBy: null,
});
export const getStatusFromContext = ({ status }, propsStatus) => propsStatus || status;
export const getAriaAttributesFromContext = ({ ariaDescribedBy }) => ariaDescribedBy ? { 'aria-describedby': ariaDescribedBy } : {};
//# sourceMappingURL=StatusContext.js.map